<div id="main-content" class="wrapper has-padding margin-height zoom-margin" (focusout)="onFocusOutMainContent($event)">
  <form *ngIf="certificationData ;  else loading" [formGroup]="certificationGroup" (ngSubmit)="onSubmit()">

    <h1 #target class="bofa--heading is-4">Professional Certifications</h1>
    <p class="global-red">Please enter any professional licenses, registrations,
      qualifications or certifications that you have.</p>

    <div *ngIf="noCertificationBand.value">
      <p>
        <mat-checkbox formControlName="noCertification">
          <mat-label class="white-space">I have no professional certification or license to list.</mat-label>
        </mat-checkbox>
      </p>
    </div>

    <div *ngIf="!noCertification.value" [class.changeDisplay]="professionalCertChange" class="flex-container">

      <div class="flex-change fx-flex-40">
        <div class="is-taller">
          <div class="level">

            <div class="level-item">
              <h2 class="bofa--heading is-6 flex-heading">Enter your certification</h2>
            </div>

          </div>
        </div>

        <div *ngFor="let certificationForm of certificationList.controls; let i = index"
          [formGroup]="certificationForm">
          <div>
            <mat-accordion multi="true" *ngIf="step === i">
              <mat-expansion-panel [expanded]="step === i" [class.border]="border" [hideToggle]="true"
                (opened)="setStep(i)" id="i" class="af-mat-card mat-elevation-z panel-width">
                <mat-expansion-panel-header class="mat-expansion outlined background-color">
                  <mat-panel-title>
                    Certification {{i+1}}
                  </mat-panel-title>
                  <mat-panel-description>
                    <div class="float-cursor-margin-left"><img src="assets/bofa_icon_close2_186rgb.svg" tabindex="0" class="height-width"
                        alt="remove certification" (keyup.enter)="deleteClick(i)"
                        (click)="deleteClick(i)" role="button" /></div>
                  </mat-panel-description>
                </mat-expansion-panel-header>

                <!-- set focus when pressing Add button -->
                <div tabindex="-1" #addElement class="bofa--skiplink">
                </div>

                <mat-form-field class="max-width max-zoom minor-list-space width-350-padding-top" hideRequiredMarker>
                  <mat-label><abbr title="required">* </abbr>Name</mat-label>
                  <input matInput formControlName="licenseName" required>
                  <mat-error>Please enter Name</mat-error>
                </mat-form-field>

                <mat-form-field class="max-width max-zoom bottom-error-space width-350" hideRequiredMarker>
                  <mat-label><abbr title="required">* </abbr> {{licenseIdText}}</mat-label>
                  <input matInput formControlName="licenseIdNumber" required>
                  <mat-hint>Enter N/A if {{licenseIdText}} does not exist</mat-hint>
                  <mat-error>Please enter {{licenseIdText}}
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="max-width max-zoom bottom-error-space width-350" hideRequiredMarker  [floatLabel]="float">
                  <mat-label><abbr title="required">* </abbr>Professional organization name or governing body
                  </mat-label>
                  <input matInput formControlName="professionalOrganizationName" required>
                  <mat-error>Please enter Professional organization name or governing body</mat-error>
                </mat-form-field>

                <mat-form-field class="max-width minor-list-space width-350" hideRequiredMarker>
                  <mat-label> <abbr title="required">* </abbr>Issue date</mat-label>
                  <input matInput [matDatepicker]="graduationDatePicker" [min]="minDate" [max]="maxDate"
                    formControlName="graduationDate">
                  <mat-datepicker-toggle matSuffix [for]="graduationDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #graduationDatePicker></mat-datepicker>
                  <mat-hint>Format mm/dd/yyyy</mat-hint>
                  <mat-error *ngIf="certificationForm.controls.graduationDate.errors">Please enter Issue date
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="max-width minor-list-space width-350" hideRequiredMarker>
                  <mat-label><abbr title="required">* </abbr>Type</mat-label>
                  <mat-select formControlName="licenseType" required>
                    <mat-option>Select</mat-option>
                    <mat-option
                      *ngFor="let licenseType of certificationData.certTypeLookup | keyvalue : valueAscOrderProfessionalLicensesFirst"
                      [value]="licenseType.key">
                      {{licenseType.value}}
                    </mat-option>
                  </mat-select>
                  <mat-hint class="bofa--skiplink">
                    <!-- Hidden for screen readers so it reads the current value selected from the dropdown -->
                    {{ dropDownScreenReaderLicenseType(certificationForm) }}
                  </mat-hint>
                  <mat-error *ngIf="certificationForm.controls.licenseType.hasError('required') ">Please select Type
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="max-width minor-list-space width-350" hideRequiredMarker>
                  <mat-label><abbr title="required">* </abbr>Organization Country</mat-label>
                  <mat-select formControlName="organizationCountry" required>
                    <mat-option>Select</mat-option>
                    <mat-option
                      *ngFor="let organizationCountry of certificationData.countryLookup | keyvalue : valueAscOrder"
                      [value]="organizationCountry.key">
                      {{organizationCountry.value}}
                    </mat-option>
                  </mat-select>
                  <mat-hint class="bofa--skiplink">
                    <!-- Hidden for screen readers so it reads the current value selected from the dropdown -->
                    {{ dropDownScreenReaderCountry(certificationForm) }}
                  </mat-hint>
                  <mat-error *ngIf="certificationForm.controls.organizationCountry.hasError('required') ">Please
                    select Organization Country
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="max-width max-zoom minor-list-space width-padding-bottom" hideRequiredMarker>
                  <mat-label> <abbr title="required">* </abbr>License origination date</mat-label>
                  <input matInput [matDatepicker]="licenseOriginationDatePicker" [min]="minDate" [max]="maxDate"
                    formControlName="licenseOriginationDate">
                  <mat-datepicker-toggle matSuffix [for]="licenseOriginationDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #licenseOriginationDatePicker></mat-datepicker>
                  <mat-hint>Format mm/dd/yyyy</mat-hint>
                  <mat-error *ngIf="certificationForm.controls.licenseOriginationDate.errors">Please enter License
                    origination date
                  </mat-error>
                </mat-form-field>

                <div class="bottom-space">
                  <div class="minor-list-space" id="af-radio-group-label"><span>Is this certification current?</span>
                  </div>
                  <mat-radio-group aria-describedby="af-radio-group-label" formControlName="isCurrentMemberShip"
                    class="bottom-space">
                    <mat-radio-button class="minor-list-space radio-padding field-space" value="1"
                      name="isCurrentMemberShip">Yes</mat-radio-button>
                    <mat-radio-button value="0" name="isCurrentMemberShip">No</mat-radio-button>
                  </mat-radio-group>
                </div>

                <div *ngIf="certificationForm.controls.organizationCountry.value ==186"
                  class="non-required middle-width minor-list-space">
                  <mat-form-field class="max-width width-310">
                    <mat-label>Organization state/region</mat-label>
                    <mat-select formControlName="organizationUsState">
                      <mat-option>Select</mat-option>
                      <mat-option *ngFor="let us of certificationData.usStateLookup | keyvalue : valueAscOrder"
                        [value]=us.key>
                        {{us.value}}
                      </mat-option>
                    </mat-select>
                    <mat-hint class="bofa--skiplink">
                      <!-- Hidden for screen readers so it reads the current value selected from the dropdown -->
                      {{ dropDownScreenReaderUsState(certificationForm) }}
                    </mat-hint>
                  </mat-form-field>
                </div>

                <div *ngIf="certificationForm.controls.organizationCountry.value !=186"
                  class="non-required middle-width minor-list-space">
                  <mat-form-field class="max-width width-310">
                    <mat-label>Organization state/region</mat-label>
                    <input matInput formControlName="organizationState">
                  </mat-form-field>
                </div>

                <div class="non-required middle-width minor-list-space">
                  <mat-form-field class="max-width width-310">
                    <mat-label>
                      Organization town/city/province</mat-label>
                    <input matInput formControlName="organizationCity">
                  </mat-form-field>
                </div>

                <div class="non-required middle-width minor-list-space">
                  <mat-form-field class="max-width width-310">
                    <mat-label>
                      Organization website/contact info</mat-label>
                    <input matInput formControlName="organizationWebsite">
                  </mat-form-field>
                </div>

                <div class="non-required middle-width minor-list-space">
                  <mat-form-field class="max-width width-310">
                    <mat-label>
                      Type of membership</mat-label>
                    <input matInput formControlName="typeOfMemberShip">
                  </mat-form-field>
                </div>

                <div class="non-required-textarea minor-list-space">
                  <mat-form-field class="width-310">
                    <mat-label id="opt-comments-label">Comments (optional)</mat-label>
                    <textarea matInput formControlName="commt" maxlength="1000" aria-labelledby="opt-comments-label"></textarea>
                    <mat-hint align="end">
                      {{(certificationForm.controls.commt.value)?certificationForm.controls.commt.value.length:0}} /
                      1000</mat-hint>
                  </mat-form-field>
                </div>

                <div class="is-taller remove-button-align">
                  <button type="button" class="bofa--button primary outlined" (click)="deleteClick(i)">Remove this
                    certification</button>
                </div>

              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </div>
      </div>

      <!-- horizonally -->
      <div *ngIf="!professionalCertChange" class="fx-flex-60">
        <div [class.sticky]="sticky" class="max-width" [style.overflow]="'auto'" #stickyDiv>
          <div class="is-taller">
            <div class="level">
              <div id="review" class="width-padding-left">
                <h2 class="bofa--heading is-6">Review your
                  certifications</h2>
              </div>
              <div class="width-padding-left" (keyup.enter)="scroll(target)" (click)="scroll(target)"> <button
                  [disabled]="certificationList.invalid" type="button" #addButtonElement
                  class="bofa--button secondary float-right" (click)="onAddCertification()">Add
                  certification</button>
              </div>
            </div>
          </div>
          <div>
            <mat-selection-list *ngIf="listCheck" aria-describedby="review" (selectionChange)="handleSelection($event)">
              <mat-list-option *ngFor="let certificationForm of certificationList.controls; let i = index" [value]="i"
                [selected]="step === i" (click)="scroll(target)" (click)="focusTarget()" (keyup.enter)="scroll(target)"
                (keyup.enter)="focusTarget()">
                <div class="is-taller">
                  <div class="level">

                    <div class="width-padding-left-margin-right-5"><span *ngIf="!certificationForm.invalid">
                        <img src="assets/bofa_icon_checkmark2.svg" class="review-icon"
                          alt="check completed certification"  /></span>
                      <span *ngIf="certificationForm.invalid">
                        <img src="assets/bofa_icon_alert.svg" class="review-icon"
                          alt="error incomplete certification"  />
                      </span>
                      <span class="padding-left-10">{{i+1}}</span>
                    </div>



                    <div class="width-margin-left-margin-right-10"> <span
                        *ngIf="certificationForm.controls.isCurrentMemberShip.value=='1'"> (Current) </span></div>
                    <div class="width-max-width-overflow-white-space-padding-left">
                      {{certificationForm.controls.licenseName.value | slice:0:20}}
                    </div>
                    <div class="width-padding-left-10">
                      {{certificationForm.controls.graduationDate.value | dateFormat }}
                    </div>
                  </div>
                </div>
                <mat-divider></mat-divider>
              </mat-list-option>
            </mat-selection-list>
          </div>
        </div>
      </div>

      <!-- show vertically -->
      <div *ngIf="professionalCertChange" class="other-top-space">
        <div class="is-taller">
          <div class="level">
            <div id="review-vertical" class="width-padding-left">
              <h2 class="bofa--heading is-6">Review your
                certifications</h2>
            </div>
            <div class="width-padding-left" (click)="scroll(target)" (keyup.enter)="scroll(target)"> <button
                [disabled]="certificationList.invalid" type="button" class="bofa--button secondary float-right"
                (click)="onAddCertification()" #addButtonElement>Add
                certification</button>
            </div>
          </div>
        </div>
        <mat-selection-list *ngIf="listCheck" aria-describedby="review-vertical"
          (selectionChange)="handleSelection($event)">
          <mat-list-option *ngFor="let certificationForm of certificationList.controls; let i = index" [value]="i"
            [selected]="step === i" (click)="scroll(target)" (click)="focusTarget()" (keyup.enter)="scroll(target)"
            (keyup.enter)="focusTarget()">
            <div class="is-taller">
              <div class="level">

                <div class="width-padding-left-margin-right-5"><span *ngIf="!certificationForm.invalid">
                    <img src="assets/bofa_icon_checkmark2.svg" class="review-icon"
                      alt="check completed certification "  /></span>
                  <span *ngIf="certificationForm.invalid">
                    <img src="assets/bofa_icon_alert.svg" class="review-icon" alt="error incomplete certification" />
                  </span>
                  <span class="padding-left-10">{{i+1}}</span>
                </div>
                <div class="width-margin-left-margin-right-10"> <span
                    *ngIf="certificationForm.controls.isCurrentMemberShip.value=='1'"> (Current) </span></div>
                <div class="width-max-width-overflow-white-space-padding-left">
                  {{certificationForm.controls.licenseName.value | slice:0:20}}
                </div>
                <div class="width-padding-left-10">
                  {{certificationForm.controls.graduationDate.value | dateFormat }}
                </div>
              </div>
            </div>
            <mat-divider aria-hidden="true"></mat-divider>
          </mat-list-option>
        </mat-selection-list>
      </div>

    </div>

    <!-- needed for skip content off focus -->
    <div *ngIf="noCertification.value">
      <div class="unClickableDiv">
        <input tabindex="-1" type="text" class="trasparentText">
      </div>
    </div>

  </form>
</div>

<ng-template #loading>
  Loading Professional Certifications...
</ng-template>